import { FC } from 'react';
import { Flex, Text, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { rem } from 'utils/fonts';
import { isCorporateThemeSelector } from 'modules/app/appSlice';
import { useSelector } from 'react-redux';
// Components
import { ReactComponent as Oops } from 'assets/svgs/Oops.svg';
import { ReactComponent as MonsterPink } from 'assets/svgs/monster_rock.svg';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';

//region styled
const StyledOops = styled(Oops)`
  width: 100%;
  height: 100%;
`;

const Info = styled(Text)`
  margin-bottom: 36px;
  font-weight: normal;
  font-size: ${rem(18)};
  text-align: center;
  max-width: 567px;
`;
//endregion

// eslint-disable-next-line no-undef
const isProduction = process.env.NODE_ENV === 'production';

interface FallbackProps {
  error: Error;
  resetError: () => void;
}

const ErrorFallback: FC<FallbackProps> = ({ error, resetError }) => {
  const { colors } = useTheme();
  const { t } = useTranslation('common');
  const isCorporateTheme = useSelector(isCorporateThemeSelector);

  return (
    <Flex direction="column" minH="100vh" justifyContent="center" alignItems="center" pt="20px">
      {!isCorporateTheme && <MonsterPink fill={colors.other.CTA} />}
      <Flex mb="54px" mt={!isCorporateTheme ? '43px' : '0px'} w="100%" maxW="360px" justify="center" sx={{ '& path': { fill: 'other.CTA' } }}>
        <StyledOops />
      </Flex>
      <Flex direction="column" align="center" w="100%" maxW="540px">
        <Info fontFamily="heading" color="secondary.800">
          {t('unexpectedErrorMessage')}
        </Info>
        {!isProduction && <Info fontFamily="heading">{error.message}</Info>}
        <Button w="194px" onClick={resetError}>
          {t('unexpectedErrorButton')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default ErrorFallback;
